import React, { useState, useEffect, useRef } from 'react';
// components
import ModalSetButton from './ModalSetButton';

const ItemButtonListItem = ({
    button,
    changeBtn,
    buttonIdx,
    delBtn,
    fixedRatio,
    buttonsLength
}) => {
    // state
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isOverflowModal, setOverflowModal] = useState(false);
    // 버튼명 maxLength: 정사각형 단일 버튼 14자, 정사각형 다중 버튼 8자, 와이드 14자
    const buttonLabelMax = fixedRatio && buttonsLength > 1 ? 8 : 14;
    // 버튼명 maxLength 맞춰서 끊음
    const changedLabelValue = button.label
        ? button.label.substring(0, buttonLabelMax)
        : '';

    // 모달
    const modalNode = useRef();
    // 모달 열기
    const openModal = () => {
        let ItemSetButtonPos = modalNode.current.getBoundingClientRect();
        let contentsWrap = modalNode.current.offsetParent.offsetParent.getBoundingClientRect();
        if (contentsWrap.right - ItemSetButtonPos.right < 241) {
            setOverflowModal(true);
        }
        setIsOpenModal(!isOpenModal);
    };
    // 모달 닫기
    const closeSet = e => {
        if (modalNode.current.contains(e.target)) {
            // inside click
            return;
        }
        setIsOpenModal(false);
    };
    // 모달 닫기
    useEffect(() => {
        // add when mounted
        document.addEventListener('mousedown', closeSet);
        // return function to be called when unmounted
        return () => {
            document.removeEventListener('mousedown', closeSet);
        };
    }, []);
    // 버튼 삭제 후 모달 닫기 콜백
    const delAfterClose = childDate => {
        setIsOpenModal(childDate);
    };

    return (
        <li ref={modalNode}>
            <button
                onClick={openModal}
                className={`${isOpenModal ? 'active' : ''}`}
            >
                {changedLabelValue}
            </button>
            {/* 설정 팝업 */}
            {isOpenModal && (
                <ModalSetButton
                    button={button}
                    buttonIdx={buttonIdx}
                    changeBtn={changeBtn}
                    isOverflowModal={isOverflowModal}
                    delBtn={delBtn}
                    delAfterClose={delAfterClose}
                    fixedRatio={fixedRatio}
                    buttonsLength={buttonsLength}
                />
            )}
        </li>
    );
};

export default ItemButtonListItem;
